import { axiosInstance, initializeTokenStorage } from '@fixit/api-client';
import { API_URL } from '@/env';

/**
 * The scoped aud:"bozp" token lives ONLY in memory (design §6.1, §12) — never localStorage.
 * A module-level variable is sufficient: the player is a single-tab SPA; a reload re-exchanges.
 */
let bozpToken: string | null = null;
let expiresAtMs: number | null = null;

export function setBozpToken(token: string, expiresInSeconds: number): void {
  bozpToken = token;
  expiresAtMs = Date.now() + expiresInSeconds * 1000;
}

export function getBozpToken(): string | null {
  return bozpToken;
}

export function getExpiresAtMs(): number | null {
  return expiresAtMs;
}

export function clearBozpToken(): void {
  bozpToken = null;
  expiresAtMs = null;
}

/**
 * Wire the shared @fixit/api-client to read the in-memory BOZP token. No refresh token
 * (getRefreshToken → null), so the axios 401 interceptor short-circuits — a single-use
 * scoped session that simply expires rather than silently refreshing.
 */
export function initBozpApiClient(): void {
  // Pin the shared client's base URL to the player's own VITE_API_URL. The
  // vite.config `process` define is supposed to inject it into the client's
  // getBaseUrl(), but the deployed bundle showed the define producing EMPTY
  // process/env objects for the source-linked api-client module (while CJS
  // deps got the value) — so the client silently fell back to
  // http://localhost:3000 and every player API call misrouted. Setting the
  // axios default here is deterministic and bundler-independent.
  axiosInstance.defaults.baseURL = API_URL;
  initializeTokenStorage({
    getAccessToken: () => bozpToken,
    getRefreshToken: () => null,
    setTokens: () => {
      /* no-op: the BOZP session is minted once via handoff exchange, never rotated */
    },
    clearTokens: () => clearBozpToken(),
  });
}
